import { atom } from "recoil";


const ServiceListAtom = atom({
    default: [],
    key: 'serviceList'
})

export default ServiceListAtom;